var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"website-footer"},[_c('div',{staticClass:"footer-box"},[_c('img',{attrs:{"src":_vm.acemap,"alt":""}}),_c('span',{staticClass:"cu-span"},[_vm._v("Contact Us: gutang@sjtu.edu.cn")])]),_c('p',[_vm._v("© Copyright 2015-2022 Acemap, Inc. Shanghai Jiao Tong University.")]),_c('p',[_vm._v("粤ICP备18023992号")])])
}
var staticRenderFns = []

export { render, staticRenderFns }